// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"4d8a2975","846":"a6c86bf9","964":"efec4ff7"}[chunkId] + ".chunk.js";
};